__turbopack_context__.v({
  "root": "rSlNcG_root",
  "sidebar": "rSlNcG_sidebar",
});
